import React from "react";

export default ({ value }) => {
  return null;
};
